module.exports = __webpack_public_path__ + "static/07-2-46dcc040e4c281f4a75ff5a4e9124ea8.jpg";